import {Button, Checkbox} from "omoplay";
import {useState} from "react";
import InputGroup from "../InputGroup";
import {postCheckNewUser} from "../../../api/project/project.api";


const ProjectDetailCheckNewUser = ({projectId, used}) => {
    const [checked, setChecked] = useState(used)

    const onSubmit = () => {
        postCheckNewUser(projectId, checked).then(() => {
            alert("저장 되었습니다.")
        })
    }

    return (
        <InputGroup label={
            <div className="flex-align-center justify-between">
                <div className="text-[16px]">특정 고객 당첨 방식 변경</div>
                <div className="flex-align-center gap-4">
                    <Button variants="dark" value="적용하기" onClick={() => onSubmit()} />
                </div>
            </div>
        } description="특정 고객의 당첨 방식을 변경합니다.">
            <div className="text-red-500 mb-2">* 변경된 내용은 반드시 사전에 안내 해주세요.</div>
            <Checkbox checked={checked} onChecked={setChecked}
                      item={{label: "이벤트에 참여한 고객이 기존 고객인 경우 확률이 가장 높은 혜택만 당첨됩니다.", value: "used"}} />

        </InputGroup>
    )
}

export default ProjectDetailCheckNewUser